import { render, staticRenderFns } from "./TheHistory.vue?vue&type=template&id=ba7a5c7e&"
import script from "./TheHistory.vue?vue&type=script&lang=js&"
export * from "./TheHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports